import { useState, useEffect } from 'react';

const ROLE_LABEL = { owner: 'DUEÑO', admin: 'ADMIN', socio: 'SOCIO', rrpp: 'RRPP', tpv: 'TPV' };
const ROLE_COLOR = { owner: '#8B0F1A', admin: '#1a4a8b', socio: '#2d6a4f', rrpp: '#7a5c00', tpv: '#3d3d3d' };

// canInvite: crear usuarios nuevos es del dueño (/api/users/invite es owner-only). El
// socio entra a esta misma pestaña para su evento, y ahi el boton no debe aparecer.
export default function TabPersonal({ event, api, reload, canInvite = true, inviteRoles }) {
  const [staff, setStaff] = useState([]);
  const [groups, setGroups] = useState([]);
  const [users, setUsers] = useState([]);
  const [groupSel, setGroupSel] = useState('');
  const [assignOpen, setAssignOpen] = useState(false);
  const [createOpen, setCreateOpen] = useState(false);
  const [commPct, setCommPct] = useState(event.commission_pct == null ? '10' : String(Number(event.commission_pct)));
  const [commSaved, setCommSaved] = useState(false);

  const loadStaff = () => api.get(`/api/events/${event.id}/staff`).then(setStaff).catch(() => {});
  useEffect(() => {
    loadStaff();
    api.get('/api/groups').then(setGroups).catch(() => {});
    api.get('/api/users').then(setUsers).catch(() => {});
  }, []); // eslint-disable-line

  async function applyGroup() {
    if (!groupSel) return;
    try { await api.post(`/api/events/${event.id}/staff/group`, { group_id: groupSel }); setGroupSel(''); loadStaff(); }
    catch (e) { alert(e.message); }
  }
  async function saveCommission() {
    const v = Math.min(100, Math.max(0, Number(commPct) || 0));
    try {
      await api.patch(`/api/events/${event.id}`, { commission_pct: v });
      setCommPct(String(v)); setCommSaved(true); setTimeout(() => setCommSaved(false), 2000);
      reload?.();
    } catch (e) { alert(e.message); }
  }
  async function removeStaff(id) {
    try { await api.del(`/api/events/${event.id}/staff/${id}`); loadStaff(); } catch (e) { alert(e.message); }
  }

  const assignedIds = new Set(staff.map(s => s.user_id));
  const assignable = users.filter(u => !assignedIds.has(u.id) && u.role !== 'owner');

  return (
    <div className="lb-fade" style={{ paddingTop: 30 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18, flexWrap: 'wrap' }}>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <select className="lb-select" style={{ padding: '10px 32px 10px 12px', fontSize: 13, minWidth: 200 }} value={groupSel} onChange={e => setGroupSel(e.target.value)}>
            <option value="">Asignar grupo RRPP…</option>
            {groups.map(g => <option key={g.id} value={g.id}>{g.name} ({g.members?.length || 0})</option>)}
          </select>
          <button className="lb-btn lb-btn--white lb-btn--sm" onClick={applyGroup} disabled={!groupSel}>Aplicar grupo</button>
        </div>
        <div style={{ marginLeft: 'auto', display: 'flex', gap: 8 }}>
          <button className="lb-btn lb-btn--ghost lb-btn--sm" onClick={() => setAssignOpen(!assignOpen)}>Asignar existente</button>
          {canInvite && <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={() => setCreateOpen(!createOpen)}>+ Crear y asignar</button>}
        </div>
      </div>

      <div className="lb-card" style={{ padding: '16px 20px', marginBottom: 18, display: 'flex', alignItems: 'center', gap: 16, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          <div className="lb-eyebrow" style={{ marginBottom: 4 }}>Comisión RRPP</div>
          <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>% que se le descuenta a cada RRPP como comisión; el resto es lo que debe rendir.</div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <div style={{ position: 'relative', width: 110 }}>
            <input className="lb-input" inputMode="decimal" value={commPct}
              onChange={e => setCommPct(e.target.value.replace(/[^\d.]/g, '').slice(0, 6))}
              style={{ paddingRight: 28, textAlign: 'right' }} />
            <span style={{ position: 'absolute', right: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--ink-600)', fontSize: 14 }}>%</span>
          </div>
          <button className="lb-btn lb-btn--white lb-btn--sm" onClick={saveCommission}>{commSaved ? 'Guardado ✓' : 'Guardar'}</button>
        </div>
      </div>

      {assignOpen && (
        <div className="lb-card" style={{ padding: '16px 20px', marginBottom: 16 }}>
          <div className="lb-eyebrow" style={{ marginBottom: 10 }}>Asignar persona existente</div>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
            {assignable.map(u => (
              <button key={u.id} className="lb-btn lb-btn--ghost lb-btn--sm" onClick={async () => { await api.post(`/api/events/${event.id}/staff`, { user_id: u.id, role_label: u.role }); loadStaff(); }}>
                + {u.full_name || u.name}
              </button>
            ))}
            {assignable.length === 0 && <div style={{ fontSize: 12, color: 'var(--ink-600)' }}>No hay más personas para asignar.</div>}
          </div>
        </div>
      )}

      {canInvite && createOpen && <CreateAndAssign event={event} api={api} roles={inviteRoles} onDone={() => { setCreateOpen(false); loadStaff(); api.get('/api/users').then(setUsers); }} />}

      <div className="lb-card tk-scroll-x" style={{ padding: '6px 24px' }}>
        <div className="lb-row lb-th" style={{ gridTemplateColumns: '1.6fr 1fr 1fr 30px' }}>
          <span>Persona</span><span>Rol</span><span>Estado</span><span></span>
        </div>
        {staff.map(s => (
          <div key={s.id} className="lb-row" style={{ gridTemplateColumns: '1.6fr 1fr 1fr 30px' }}>
            <div>
              <div style={{ fontFamily: 'var(--font-display)', fontWeight: 600, fontSize: 13, textTransform: 'uppercase', color: '#fff' }}>{s.full_name || s.name}</div>
              <div style={{ fontSize: 11, color: 'var(--ink-600)' }}>{s.email}</div>
            </div>
            <span><span className="lb-status lb-status--dot" style={{ borderColor: ROLE_COLOR[s.role], color: '#fff' }}>{ROLE_LABEL[s.role] || s.role}</span></span>
            {/* Mientras no acepta la invitación, el nombre es un provisorio sacado
                del email (CAROLINA.GOMEZ) y no tiene apellido: hay que poder verlo
                de un vistazo para reenviarle la invitación antes de la noche. */}
            <span><span className={'lb-status ' + (s.invite_pending ? 'lb-status--gen' : s.active ? 'lb-status--paid' : 'lb-status--gen')}>
              {s.invite_pending ? 'Sin aceptar' : s.active ? 'Activo' : 'Inactivo'}
            </span></span>
            <button className="lb-iconbtn" onClick={() => removeStaff(s.id)}>✕</button>
          </div>
        ))}
        {staff.length === 0 && <div style={{ padding: '24px 0', textAlign: 'center', fontSize: 13, color: 'var(--ink-600)' }}>Sin personal asignado. Asigná un grupo o personas.</div>}
      </div>
    </div>
  );
}

// roles: que roles puede crear quien esta mirando. El socio arma su equipo de RRPP y
// nada mas; el backend se lo fuerza igual, esto es para no ofrecerle lo que va a fallar.
function CreateAndAssign({ event, api, onDone, roles }) {
  const OPCIONES = roles && roles.length ? roles : ['rrpp', 'admin', 'socio'];
  const LABEL = { rrpp: 'RRPP', admin: 'Admin', socio: 'Socio' };
  const [f, setF] = useState({ email: '', role: 'rrpp' });
  const [saving, setSaving] = useState(false);
  async function save() {
    if (!f.email.trim()) { alert('Ingresá el email'); return; }
    setSaving(true);
    try {
      const r = await api.post('/api/users/invite', { email: f.email.trim(), role: f.role, event_id: event.id });
      alert(r.sent ? `Invitación enviada a ${f.email.trim()}. Cuando la acepte, elige su propia contraseña.` : `Invitación creada. ${r.invite_url ? 'Link: ' + r.invite_url : 'No se pudo enviar el email — revisá la casilla.'}`);
      onDone();
    } catch (e) { alert(e.message); } finally { setSaving(false); }
  }
  return (
    <div className="lb-card" style={{ padding: '16px 20px', marginBottom: 16 }}>
      <div style={{ display: 'grid', gridTemplateColumns: '2fr 0.9fr auto', gap: 10, alignItems: 'end' }}>
        <Field label="Email"><input className="lb-input" type="email" value={f.email} onChange={e => setF({ ...f, email: e.target.value })} placeholder="rrpp@email.com" /></Field>
        <Field label="Rol">
          <select className="lb-select" value={f.role} onChange={e => setF({ ...f, role: e.target.value })}>
            {OPCIONES.map(o => <option key={o} value={o}>{LABEL[o] || o}</option>)}
          </select>
        </Field>
        <button className="lb-btn lb-btn--primary lb-btn--sm" onClick={save} disabled={saving}>{saving ? 'Enviando…' : 'Invitar'}</button>
      </div>
      <div style={{ fontSize: 11.5, color: 'var(--ink-600)', marginTop: 8 }}>Le llega una invitación por email para completar su registro y elegir su contraseña. Queda asignado a este evento.</div>
    </div>
  );
}

function Field({ label, children }) {
  return <div className="lb-field"><div className="lb-label">{label}</div>{children}</div>;
}
